export default {
  default: '/',
  index: '/index',
  investments: '/investments',
  investmentDetails: '/investments/investmentsDetails',
  news: '#',
  aboutUs: '#',
  FAQ: '#',
  contactUs: '#',
  notifications: '/notifications',
  announcements: '/announcements',
  // investments: '/investments',
  // news: '/news',
  // aboutUs: '/aboutUs/aboutUs',
  // FAQ: '/FAQ',
  // contactUs: '/contactUs',
};